// app/hub/[bookmaker]/components/BookmakerHeader/BookmakerStats.tsx

import type { FC } from 'react';
import { FlashIcon as Flash } from '@/components/icons/FlashIcon';

interface BookmakerStatsProps {
  PayoutTime: string;
  FirstDepositBonus: string;
  isDesktop?: boolean;
}

export const BookmakerStats: FC<BookmakerStatsProps> = ({
  PayoutTime,
  FirstDepositBonus,
  isDesktop = false,
}) => {
  const innerContainerClass = isDesktop ? 'px-2' : 'px-4';

  return (
    <div className="max-w-[200px] lg:max-w-[150px]">
      <div className="flex flex-col gap-1">
        <div
          className={`flex flex-col justify-start ${innerContainerClass} gap-1 py-[6.5px] ${isDesktop ? 'h-[53px]' : ''}`}
        >
          <p className="font-normal text-gray text-xs leading-3">Payout time</p>
          <div className="flex flex-row gap-[6px]">
            <Flash desc="Fast payout time icon" title="Fast Payout" />
            <p
              className={`font-semibold text-base leading-[25px] ${isDesktop ? 'tracking-[0.01em]' : ''}`}
            >
              {PayoutTime}
            </p>
          </div>
        </div>
        <div
          className={`flex flex-col justify-start ${innerContainerClass} gap-1 py-[6.5px] ${isDesktop ? 'h-[53px]' : ''}`}
        >
          <p className="font-normal text-gray text-xs leading-3">
            First deposit bonus
          </p>
          <p
            className={`font-semibold text-base leading-[25px] ${isDesktop ? 'tracking-[0.01em]' : ''}`}
          >
            {FirstDepositBonus}
          </p>
        </div>
      </div>
    </div>
  );
};
